import { DicteeBouton, ajouterTexte } from "@/components/assistant/DicteeBouton";

export const Champ = ({ label, id, dictee, ...props }) => (
  <label htmlFor={id} className="block">
    <span className="at-label block mb-1.5">{label}</span>
    {dictee ? (
      <span className="flex gap-2">
        <input id={id} className="at-input" {...props} />
        <DicteeBouton testId={`${id}-dictate`} onTexte={(t) => props.onChange({ target: { value: ajouterTexte(props.value, t) } })} />
      </span>
    ) : <input id={id} className="at-input" {...props} />}
  </label>
);

export const EnTete = ({ titre, sousTitre, children }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6">
    <div>
      <h1 className="text-3xl sm:text-4xl font-bold tracking-tight" data-testid="page-title">{titre}</h1>
      {sousTitre && <p className="at-muted mt-1.5 text-sm md:text-base">{sousTitre}</p>}
    </div>
    {children}
  </div>
);

export const PastilleEtape = ({ fiche, testId }) => {
  const c = fiche.temperature || "var(--muted)";
  return (
    <span data-testid={testId} className="inline-flex items-center gap-1.5 px-2.5 py-1 at-pill text-xs font-semibold whitespace-nowrap"
      style={{ background: `color-mix(in srgb, ${c} 14%, transparent)`, color: c }}>
      <span className="w-2 h-2 at-pill" style={{ background: c }} />
      {fiche.etape_label}
    </span>
  );
};

export const Vide = ({ texte, testId }) => (
  <div data-testid={testId} className="at-card p-8 text-center at-muted">{texte}</div>
);

export const EchelleTemperature = () => (
  <div className="flex h-2 at-pill overflow-hidden" data-testid="temperature-scale">
    {[1, 2, 3, 4, 5, 6, 7].map((i) => <span key={i} className="flex-1" style={{ background: `var(--temp-${i})` }} />)}
  </div>
);
